import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { MenuItems } from "Shared/Components/Layout/Full/Sidebar/MenuItems";
import { NavCollapse } from "Shared/Components/Layout/Full/Sidebar/NavCollapse";
import { NavGroup } from "Shared/Components/Layout/Full/Sidebar/NavGroup/NavGroup";
import { NavItem } from "Shared/Components/Layout/Full/Sidebar/NavItem";
import { Box, List } from "@mui/material";
import { useAtom } from "jotai";
import { useLocation } from "react-router";

export const SidebarItems = () => {
	const [themeConfiguration, setThemeConfiguration] = useAtom(themeAtom);
	const { pathname } = useLocation();
	const pathDirect = pathname;

	return (
		<Box sx={{ px: 2 }}>
			<List sx={{ pt: 0 }}>
				{MenuItems.map((item) => {
					const pathWithoutLastPart =
						item.href !== pathname
							? pathname.slice(0, pathname.lastIndexOf("/"))
							: pathname;

					if (item.subheader) {
						return <NavGroup item={item} key={item.subheader} />;
					}

					if (item.children) {
						return (
							<NavCollapse
								menu={item}
								pathDirect={pathDirect}
								pathWithoutLastPart={pathWithoutLastPart}
								level={item.level ?? 1}
								key={item.id}
								onClick={() =>
									setThemeConfiguration({
										...themeConfiguration,
										isMobileSidebar: false,
									})
								}
							/>
						);
					}

					return (
						<NavItem
							item={item}
							key={item.id}
							level={item.level ?? 1}
							pathDirect={pathDirect}
							onClick={() =>
								setThemeConfiguration({
									...themeConfiguration,
									isMobileSidebar: true,
								})
							}
						/>
					);
				})}
			</List>
		</Box>
	);
};
